// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plans_container {
    margin-bottom: 20px;
}
.plans_container_header {
    width: 100%;
    height: 73px;
    background-color: white;
    border-radius: 5px;
    padding: 10px 20px;
}
.plans_close {
    padding-left: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #A2ADBF;
}
.plans_container_main {
    background-color: white;
    width: 100%;
    padding: 3rem 20px 1.5rem 20px;
    border-radius: 5px;
    position: relative;
}
.plans_title {
    padding-top: 20px;
    font-size: 18px;
    font-weight: 600;
    font-family: Montserrat, sans-serif;
    color: black;
}
.plans_text {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0,0,0,0.8);
    line-height: 38px;
    padding-bottom: 20px;
}
.plans_success_wrapper {
    max-width: 600px;
}
.plans_success_wrapper > p {
    font-size: 0.8rem;
}
.plans_success_wrapper > h3 {
    font-size: 1rem;
}
.plans_success_title {
    font-weight: 600;
    font-size: 1.4rem;
}
.plans_success_box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #CDE1EB;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    margin-bottom: 15px;
}
.plans_success_img {
    position: absolute;
    bottom: 0;
    left: 5%;
}
@media (max-width: 1000px) {
    .plans_success_img {
        max-width: 20%;
    }
}
@media (max-width: 600px) {
    .plans_success_img {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Containers/PlansContainer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".plans_container {\n    margin-bottom: 20px;\n}\n.plans_container_header {\n    width: 100%;\n    height: 73px;\n    background-color: white;\n    border-radius: 5px;\n    padding: 10px 20px;\n}\n.plans_close {\n    padding-left: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #A2ADBF;\n}\n.plans_container_main {\n    background-color: white;\n    width: 100%;\n    padding: 3rem 20px 1.5rem 20px;\n    border-radius: 5px;\n    position: relative;\n}\n.plans_title {\n    padding-top: 20px;\n    font-size: 18px;\n    font-weight: 600;\n    font-family: Montserrat, sans-serif;\n    color: black;\n}\n.plans_text {\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(0,0,0,0.8);\n    line-height: 38px;\n    padding-bottom: 20px;\n}\n.plans_success_wrapper {\n    max-width: 600px;\n}\n.plans_success_wrapper > p {\n    font-size: 0.8rem;\n}\n.plans_success_wrapper > h3 {\n    font-size: 1rem;\n}\n.plans_success_title {\n    font-weight: 600;\n    font-size: 1.4rem;\n}\n.plans_success_box {\n    width: 100%;\n    height: 60px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #CDE1EB;\n    padding-left: 10px;\n    padding-right: 10px;\n    border-radius: 5px;\n    margin-bottom: 15px;\n}\n.plans_success_img {\n    position: absolute;\n    bottom: 0;\n    left: 5%;\n}\n@media (max-width: 1000px) {\n    .plans_success_img {\n        max-width: 20%;\n    }\n}\n@media (max-width: 600px) {\n    .plans_success_img {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
